import { SVGProps } from "react";

export default function StepIcon4(props: SVGProps<SVGSVGElement>) {
  return (
<svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.834 2.5C17.7545 2.5 18.5007 3.24619 18.5007 4.16667V15.8333C18.5007 16.7538 17.7545 17.5 16.834 17.5C15.9135 17.5 15.1673 16.7538 15.1673 15.8333V4.16667C15.1673 3.24619 15.9135 2.5 16.834 2.5Z" stroke="currentColor" strokeWidth="1.5"/>
<path d="M3.50065 9.16667C4.42113 9.16667 5.16732 9.91286 5.16732 10.8333L5.16732 15.8333C5.16732 16.7538 4.42113 17.5 3.50065 17.5C2.58018 17.5 1.83398 16.7538 1.83398 15.8333L1.83398 10.8333C1.83398 9.91286 2.58018 9.16667 3.50065 9.16667Z" stroke="currentColor" strokeWidth="1.5"/>
<path d="M10.1673 5.83333C11.0878 5.83333 11.834 6.57953 11.834 7.5V15.8333C11.834 16.7538 11.0878 17.5 10.1673 17.5C9.24684 17.5 8.50065 16.7538 8.50065 15.8333L8.50065 7.5C8.50065 6.57953 9.24684 5.83333 10.1673 5.83333Z" stroke="currentColor" strokeWidth="1.5"/>
</svg>
 );
};
